"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscriptionContext = exports.useFormSelector = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const selector_context_1 = require("./selector-context");
const subscription_context_1 = require("./subscription-context");
const force_render_1 = require("../../../utils/force-render");
/**
 * Gets value from form at selected place.
 *
 * fixme: add support for FormFieldContext.
 *
 * @param selector Selector function accepting the form object and returning the value
 * @param providedContext Custom context for accessing parent form
 * @param comparator Comparator function to detect value change. Defaults to lodash deep compare
 */
function useFormSelector(selector, providedContext, comparator = lodash_1.isEqual) {
    const { selector: rootSelector = (values) => values } = react_1.useContext(selector_context_1.SelectorContext);
    const combinedSelector = (values) => { var _a; return selector((_a = rootSelector(values)) !== null && _a !== void 0 ? _a : {}); };
    const defaultContext = react_1.useContext(subscription_context_1.SubscriptionContext);
    const context = providedContext !== null && providedContext !== void 0 ? providedContext : defaultContext;
    const { forceRender } = force_render_1.useForceRender();
    const valueRef = react_1.useRef(context.getValue(combinedSelector));
    react_1.useEffect(() => {
        // creates subscription
        const checkForUpdates = () => {
            const newValue = context.getValue(combinedSelector);
            if (!comparator(newValue, valueRef.current)) {
                valueRef.current = newValue;
                forceRender();
            }
        };
        context.subscriptions.add(checkForUpdates);
        // removes subscription
        return () => {
            context.subscriptions.delete(checkForUpdates);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context]);
    return valueRef.current;
}
exports.useFormSelector = useFormSelector;
/**
 * Creates new form subscription context.
 *
 */
function useSubscriptionContext(getValues) {
    /**
     * Form values.
     */
    /**
     * Subscriptons is mutable set, therefore use Ref instead of State.
     */
    const subscriptions = react_1.useRef(new Set());
    /**
     * Calls all subscribed handlers.
     */
    const fireSubscriptions = event_callback_hook_1.useEventCallback(() => {
        subscriptions.current.forEach((subscription) => subscription());
    });
    const parent = react_1.useContext(subscription_context_1.SubscriptionContext);
    /**
     * Context object needs to be memoized.
     */
    const subscriptionContext = react_1.useMemo(() => ({
        subscriptions: subscriptions.current,
        getValue: (selector) => selector(getValues()),
        parent,
    }), [getValues, parent]);
    return { subscriptionContext, fireSubscriptions };
}
exports.useSubscriptionContext = useSubscriptionContext;
//# sourceMappingURL=selector.js.map